import React, { useMemo, useRef } from "react";
import { OverlayTrigger, Tooltip as BootstrapTooltip } from "react-bootstrap";
import cx from 'classnames';
import styles from './tooltip.module.scss';
import { Placement } from "react-bootstrap/esm/types";
import { OverlayTriggerType } from "react-bootstrap/esm/OverlayTrigger";

interface TooltipProps {
  show?: boolean;
  placement: Placement;
  className?: string;
  content?: string | React.ReactNode;
  children: React.ReactNode;
  disabled?: boolean;
  container?: HTMLElement;
  nowrap?: boolean;
}

const Tooltip: React.FC<TooltipProps> = ({show, placement, className, content, children, disabled, nowrap }) => {
  const idRef = useRef(Math.random().toString(36).substring(7));
  const trigger = useMemo(() => ['hover', 'focus'], []) as OverlayTriggerType[];

  if (!content || disabled) {
    return <>{children}</>;
  }

  return (
    <OverlayTrigger
      show={show}
      container={document.body}
      placement={placement}
      trigger={trigger}
      overlay={
        <BootstrapTooltip className={cx(styles.tooltip, { [styles.nowrap]: nowrap }, className)} placement={placement} id={idRef.current}>
          {content}
        </BootstrapTooltip>
      }
    >
      {React.isValidElement(children) ? children : <span>{children}</span>}
    </OverlayTrigger>
  );
}

export default Tooltip;